import type { FaireProductEntity } from "../../entity_types/product";

export const p_xutzw3rk3z: FaireProductEntity = {
  token: "p_xutzw3rk3z",
  type: "product",
  name: "christmas checklist notepad",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl: "https://cdn.faire.com/fastly/714f6d8b091f58b25c3873d0a3342411a38ba5233186f54c45783c656bd7a141.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e69183798fd5e06188d881c9280e27b4fe7fbf16bb61e93d958953c9a734938.jpeg",
    "https://cdn.faire.com/fastly/bff61223cb3d5af9dfee3aebee56cbc14c184cad87c1f432571e4326851c512b.jpeg",
    "https://cdn.faire.com/fastly/05c48cedf8ee52d97a4c99c5812d6cef877874a432aac0fd29ebbc5aea381455.jpeg",
    "https://cdn.faire.com/fastly/f9bd3d0051770bde24c0dc1dcbc0e4c5a9f71f7cd4092f5cacaf24a5dcfc60ca.jpeg",
    "https://cdn.faire.com/fastly/ed848cecf59f8085a78df64e381682637b870039fbae9783908f77c037d76206.jpeg",
    "https://cdn.faire.com/fastly/497d31baf61592b29b6f5685271b97c7582cdf40ea3cc2d8efbaed01063fa269.jpeg"
  ],
  priceDollars: 8.5,
  description: "Stay Organized and Festive This Holiday Season\n\nTransform your holiday tasks into calming delight with this beautifully illustrated Christmas checklist notepad. Whether you're gift shopping, coordinating meals, or managing seasonal to-dos, this notepad keeps everything in one charming place.\n\nWhy You'll Love It:\n\n * never forget a thing – checkboxes for easily tracking tasks or items \n * perfectly portable – 5\" x 7\" size fits in your purse, tote, or on your desk for planning on the go \n * built to last the season – 50 tear-off pages with sturdy cardboard backing means you're covered through all your holiday planning \n * functional and beautiful – Original watercolor illustrations by Emily Lex add a touch of festive charm to your daily planning\n\nPerfect for busy parents juggling holiday activities, thoughtful gift-givers tracking their shopping lists, or anyone who loves the satisfaction of checking off completed tasks.\n\nDetails:\n\n * 50 easy tear-off sheets \n * 5\" x 7\" inch notepad size \n * Lined pages with checkboxes \n * Cardboard backing for stability \n * Original watercolor artwork by Emily Lex \n * Made in the USA ",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:10.348Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
